/* ============================================================
   viewport.js — mobile shell fixes (2026-09)
   Single source of truth for "is this a mobile-width viewport", so every
   mobile gate (tours, coach-marks, ...) agrees with each other and with
   the mobile CSS breakpoint used across shell.css / dashboard.css.
   ============================================================ */

const MOBILE_QUERY = '(max-width: 768px)';

/**
 * True when the viewport matches the app's mobile breakpoint. Wrapped in a
 * try/catch so it degrades to false in environments without a real
 * `window.matchMedia` (SSR, plain vitest/node tests) instead of throwing.
 */
export function isMobileViewport() {
  try {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(MOBILE_QUERY).matches;
  } catch (_) {
    return false;
  }
}

/**
 * Pure decision for the Dashboard "?tour=1" coach-mark (DashboardTour):
 * mobile never starts it, and — crucially — the trigger site must leave
 * the one-shot `tour` param UNCONSUMED when it bails on mobile, so the
 * exact same link still starts the tour later on desktop. Exported as a
 * standalone pure function (no React, no DOM reads beyond the `mobile`
 * flag) so the gate is testable without rendering Dashboard.jsx.
 */
export function shouldStartDashboardTour(hasTourParam, mobile = isMobileViewport()) {
  return Boolean(hasTourParam) && !mobile;
}
